/* global rp$, window, grecaptcha */

import './contact_form.scss';
const utils = require('public/js/helpers/utils');

var THE_SCRIPT = function () {

	const $onReady = require('public/js/lib/on-ready');
	// require('select2');

	(function ContactFormModule() {
		'use strict';
		$onReady({
			rp$, window,
			label: 'contact_form',
			fn: function () {
				var $contactForms, $contactFormEle, $successEle, $errorsEle, $successMessageEle, $successDealerMessageEle, $successOrderDealerMessageEle;

				let dropDownWrapper;
				let dropDowns;
				const dropDownWrapperSelector = '.dealer-picker-dropdown';
				const dropDownSelector = '.dropdown';
				const toggleButtonSelector = '.dropdown-toggle';
				const filterInputSelector = '.dropdown-search-input';
				const dropDownOptionClass = 'dropdown-item';
				const dropDownOptionSelector = `.${dropDownOptionClass}`;
				const OPTION_ATTRIBUTES = {
					value: 'data-value',
					display: 'data-display',
					type: 'data-type',
					label: 'data-label',
				};

				$contactForms = rp$('.contact-form-module');

				rp$.each($contactForms, function ContactFormModule_Iterator(idx, contactFormEle) {
					$contactFormEle = rp$(contactFormEle);
					$successEle = $contactFormEle.find('.success-overlay');
					$errorsEle = $contactFormEle.find('.contact-form-errors');
					$successMessageEle = $contactFormEle.find('.form-success-message');
					$successDealerMessageEle = $contactFormEle.find('.form-success-dealer-message');
					$successOrderDealerMessageEle = $contactFormEle.find('.form-success-order-dealer-message');

					window.getCaptchaToken = function(token) {
						contactFormSubmit();
					}

					function contactFormWorking() {
						$contactFormEle.find('.contact-form-submit').addClass('disabled');
					}
					function contactFormReady() {
						$contactFormEle.find('.contact-form-submit').removeClass('disabled');
					}

					function contactFormHandleErrors(errors) {
						var errorsEleOffset, windowHeight, windowTop;

						/* Fill errors
						.*-----------------------------------------*/
						$errorsEle.show().empty();
						for(var i = 0, j = errors.length; i < j; i++) {
							var errMsg = errors[i];
							$errorsEle.append('<p>'+ errMsg +'</p>');
						}

						// Recaptcha submission is invalidated. Reload it.
						if(typeof grecaptcha === 'object') {
							grecaptcha.reset();
						}

						/* If errors are out of view (above or below window pane), scroll to it
						.*-----------------------------------------*/
						errorsEleOffset = $errorsEle.offset();
						windowHeight = rp$(window).height();
						windowTop = rp$(window).scrollTop();
						if((errorsEleOffset.top < windowTop) || (errorsEleOffset.top > (windowTop + windowHeight))) {
							rp$('html, body').animate({
								scrollTop: $errorsEle.offset().top - 40
							});
						}

						focusFirstEmpty($contactFormEle);
					}

					function contactFormHandleSuccess(request) {
						$successEle.fadeIn();
						if (request.sentTo === 'selectedDealer') {
							$successDealerMessageEle.html($successDealerMessageEle.html().replace('{dealer_name}', request.supplier));

							$successMessageEle.empty();
							$successOrderDealerMessageEle.empty();
						} else if (request.sentTo === 'orderDealer') {
							$successOrderDealerMessageEle.html($successOrderDealerMessageEle.html().replace('{dealer_name}', request.supplier));

							$successMessageEle.empty();
							$successDealerMessageEle.empty();
						} else {
							$successDealerMessageEle.empty();
							$successOrderDealerMessageEle.empty();
						}
						$errorsEle.addClass('hidden').empty();
					}

					function focusFirstEmpty($form) {
						var fields = ['name','email','phone-number','reason','brand','order-id','vin','subject','message'];
						for (var i = 0; i < fields.length; i++) {
							var field = $form.find('.msg-'+ fields[i]);
							var validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
							if(!field.val()) {
								field.focus();
								break;
							} else if(fields[i] == 'email' && !field.val().match(validEmailRegex)) {
								field.focus();
								break;								
							}
						}
					}

					function attachInputEvents($contactForm) {
						$contactForm.find('input, select, textarea')
							.on('blur', function(){
								if(!rp$(this).val()){
									rp$(this).closest('.field').removeClass('active');
								}
							})
							.on('focus', function(){
								rp$(this).closest('.field').addClass('active');
							})
							.on('input change', function(){
								if(rp$(this).val()){
									rp$(this).closest('.field').addClass('active');
								} else {
									rp$(this).closest('.field').removeClass('active');
								}
							});
					}

					function closeDealerDropDown() {
						rp$(`${dropDownSelector}.open`, dropDownWrapper).removeClass('open');
					}
				
					function getDropDownByType(type) {
						let dropDown;
						dropDowns.each(function () {
							const $elem = rp$(this);
							if($elem.attr(OPTION_ATTRIBUTES.type) === type) {
								dropDown = $elem;
								return false;
							}
						});
						return dropDown;
					}
				
					function updateDealerButtonText($elem, label) {
						$elem.find('.label-value').text(label);
					}
				
					function filterOptions(event) {
						const type = event.target.getAttribute(OPTION_ATTRIBUTES.type);
						const dropDown = getDropDownByType(type);
						if (!type || !dropDown) {
							return;
						}

						const $options = rp$(dropDownOptionSelector, dropDown);
						if (event.keyCode === 40) {
							$options.first().focus();
						} else if(event.keyCode === 13) {
							const $visibleOptions = rp$(`${dropDownOptionSelector}:visible`, dropDown);
							const target = $visibleOptions.first();
							handleOptionClick(event, target[0]);
						} else {
							const value = event.target.value.replace(/\W+/g, "-").toLowerCase();
							$options.each(function () {
								const optionDisplay = this.getAttribute(OPTION_ATTRIBUTES.display).toLowerCase();
								rp$(this).parent().toggle(optionDisplay.includes(value));
							});
						}
					}

					function getActiveValue($elem) {
						return $elem.find(`${dropDownOptionSelector}.active`).attr(OPTION_ATTRIBUTES.value);
					}
	
					function getDealer() {
						let data = null;
						dropDowns.each(function() {
							const $elem = rp$(this);
							data = getActiveValue($elem);
						});
						return data;
					}
					
					function toggleClass($target, className) {
						$target.closest(dropDownSelector).find('.' + className).removeClass(className);
						$target.addClass(className);
					}
				
					function updateDealerDropDown(target) {
						const $target = rp$(target);
						const type = $target.attr(OPTION_ATTRIBUTES.type);
						const label =  $target.attr(OPTION_ATTRIBUTES.display);
						const dropDown = getDropDownByType(type);
	
						toggleClass($target, 'active');
						updateDealerButtonText(dropDown, label);
						closeDealerDropDown();
					}
				
					function handleOptionClick(event, element) {
						event.preventDefault();
						event.stopPropagation();
						const target = element || event.target;
						updateDealerDropDown(target);
					}
				
					function handleDropDownClick(event) {
						setTimeout(() => {
							focusFilterInput(event.target);
						});
					}
				
					function focusFilterInput(elem) {
						const $elem = rp$(elem);
						$elem.closest(dropDownSelector).find(filterInputSelector).focus();
					}
				
					function init() {
						dropDownWrapper = rp$(dropDownWrapperSelector);
						dropDowns = rp$('[class*="-dropdown"]', dropDownWrapper);
				
						rp$(toggleButtonSelector, dropDownWrapper).on('click', handleDropDownClick);
						rp$(dropDownOptionSelector, dropDownWrapper).on('click', handleOptionClick);
						rp$(filterInputSelector, dropDownWrapper).each(function () {
							rp$(this).on('keyup', filterOptions);
						});
					}
	
					init();					

					attachInputEvents($contactFormEle);
					focusFirstEmpty($contactFormEle);

					function contactFormSubmit() {
						var form = {
							dealer: null,
							name: null,
							email: null,
							phone: null,
							reason: null,
							brand: null,
							orderNum: null,
							vin: null,
							subject: null,
							message: null,
							captchaResponse: null
						};

						/* Pull in data from the form
						.*-----------------------------------------*/

						form.dealer = getDealer();
						form.name = $contactFormEle.find('.msg-name').val();
						form.email = $contactFormEle.find('.msg-email').val();
						form.phone = $contactFormEle.find('.msg-phone-number').val();
						form.reason = $contactFormEle.find('.msg-reason').val();
						form.brand = $contactFormEle.find('.msg-brand').val();
						form.orderNum = $contactFormEle.find('.msg-order-id').val();
						form.vin = $contactFormEle.find('.msg-vin').val();
						form.subject = $contactFormEle.find('.msg-subject').val();
						form.message = $contactFormEle.find('.msg-message').val();
						// Recapchta fields
						form.captchaResponse = null;
						if(typeof grecaptcha === 'object') {
							form.captchaResponse = grecaptcha.getResponse();
						}

						/* Perform Submission
						.*-----------------------------------------*/
						contactFormWorking();
						window.rp_app.request({
							method: 'POST',
							url: '/ajax/contact-us',
							dataType: 'json',
							data: form,
							success: function contactFormSubmit_Success(response) {
								if(window.tracking.google.use_gtag_admind_analytics){
									delete form.captchaResponse;
									Promise.all([
										utils.hashSensitiveInformation(form.name),
										utils.hashSensitiveInformation(form.email),
										utils.hashSensitiveInformation(form.phone),
										utils.hashSensitiveInformation(form.vin)
									]).then(function (hashedValues) {
										form.name = hashedValues[0];
										form.email = hashedValues[1];
										form.phone = hashedValues[2];
										form.vin = hashedValues[3];
										window.rp_app.track.track_ec_contact_us('contact_us', form);
									});
								} 
								contactFormHandleSuccess(response);
							},
							statusCode: {
								400: function(jqxhr) {
									contactFormReady();
									var error_details;
									if(jqxhr.hasOwnProperty('responseText')) {
										try {
											error_details = JSON.parse(jqxhr.responseText);
										} catch(e) {
											error_details = {
												errors: [javascriptContent.form_submission_general_error]
											};
										}
									}
									contactFormHandleErrors(error_details.errors);
								}
							},
							error: function contactFormSubmit_Error(jqxhr/*, status error*/) {
								if(typeof this.statusCode[jqxhr.status] === 'function') { return; } // StatusCode handled
								contactFormReady();
								contactFormHandleErrors([javascriptContent.general_request_error]);
							}
						});
					}

					// attach select2 UX to select inputs
					// $contactFormEle.find('select.msg-reason').select2();
					// $contactFormEle.find('select.msg-brand').select2();
					// attach form submit handler
					$contactFormEle.on('click', '.contact-form-submit', function (evt) {
						evt.preventDefault();
						if(rp$(this).hasClass('disabled')) {
							return;
						}

						if (typeof grecaptcha === 'object') {
							grecaptcha.execute();
						} else {
							contactFormSubmit();
						}
					});

					$contactFormEle.on('click', '.close-button', function (evt) {
						$successEle.remove();
						window.location.reload();
					});
				});
			},
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
